import { isLocalService, shouldForce401, shouldUseLocalBackend } from './localRequestUtils';
import { createCombinedAbortSignal } from './abortSignalUtils';
import { getAvroGateway, ChirpInternalError } from './chirp-avro';
export async function makeChirpAvroCall({
  hubHttpClient,
  details,
  responseParser,
  inputs,
  alternateData,
  calledFrom = 'bend',
  rpcFetcherFactory,
  fetcherOverride
}) {
  var _inputs$request;
  const {
    timeout,
    portalId,
    userId,
    environment,
    hublet
  } = inputs !== null && inputs !== void 0 ? inputs : {};
  const request = (_inputs$request = inputs === null || inputs === void 0 ? void 0 : inputs.request) !== null && _inputs$request !== void 0 ? _inputs$request : {};
  const {
    auth,
    serviceName,
    rpcName,
    fingerprint,
    na1Only,
    isHublessAppAuth,
    isLocal,
    routingLocality
  } = details;
  const syncStackError = new Error(`CHIRP RPC failed for ${rpcName}`);
  const clientTimeout = typeof timeout === 'number' ? timeout : 5000;
  const shouldMakeLocalRequest = isLocal || shouldUseLocalBackend(isLocal) && (await isLocalService(serviceName));
  const headers = {};
  if (fingerprint !== undefined) {
    headers['x-hs-fingerprint'] = fingerprint;
  }
  if (portalId !== undefined && (auth === 'internal' || calledFrom === 'npmShim')) {
    headers['X-Origin-HubId'] = String(portalId);
  }
  if (userId !== undefined) {
    headers['X-Origin-UserId'] = String(userId);
  }
  const gatewayUrl = `${getAvroGateway({
    auth,
    timeout: clientTimeout,
    isLocal: shouldMakeLocalRequest,
    na1Only,
    isHublessAppAuth,
    isRoutedGlobally: routingLocality === 'GLOBAL'
  })}/${serviceName}/${rpcName}`;
  const makeHubHttpRequest = () => hubHttpClient.post(gatewayUrl, Object.assign({
    data: request,
    headers,
    timeout: clientTimeout,
    query: {
      clienttimeout: String(clientTimeout)
    },
    environment,
    hublet
  }, portalId && auth === 'app' && calledFrom !== 'npmShim' ? {
    portalId
  } : {})).catch(errorResponse => {
    if (errorResponse.status !== 0 && 'responseJSON' in errorResponse) {
      const isAuthError = errorResponse.status === 401;
      return Object.assign({}, isAuthError ? {
        isAuthError: true
      } : {}, errorResponse.responseJSON);
    }
    throw errorResponse;
  });
  const makeChirpFetchRequest = () => {
    const fetcher = fetcherOverride !== null && fetcherOverride !== void 0 ? fetcherOverride : rpcFetcherFactory(auth, environment, hublet);
    const signal = createCombinedAbortSignal(clientTimeout);
    return fetcher(`${gatewayUrl}?clienttimeout=${clientTimeout}`, {
      method: 'POST',
      headers: Object.assign({
        'Content-Type': 'application/json'
      }, headers),
      body: JSON.stringify(request),
      signal
    }).then(async response => {
      if (response.status === 401 || shouldForce401()) {
        throw Object.assign(new ChirpInternalError('Unauthorized'), {
          isAuthError: true,
          serviceName
        });
      }
      const json = await response.json();
      return json;
    });
  };
  const data = alternateData !== null && alternateData !== void 0 ? alternateData : hubHttpClient ? makeHubHttpRequest() : makeChirpFetchRequest();
  return data.then(response => responseParser(response, serviceName)).catch(error => {
    syncStackError.cause = error;
    throw syncStackError;
  });
}